import styles from "./BaseTextarea.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const BaseTextarea = (props: {
  type: string;
  label?: string;
  placeholder: string;
  inputkey?: string;
  value?: string | number | null;
  disable?: boolean;
  inputType?: string;
  onChange?: (e: any) => void;
  errorMessage?: string;
}) => {
  const {
    placeholder,
    value,
    inputType = "text",
    type,
    label,
    onChange,
    errorMessage,
  } = props;

  return (
    <div className={cx("base-input-v2-container")}>
      {label && <h3 className={cx("input-label")}>{label}</h3>}
      <textarea
        // type={inputType}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={onChange}
        className={cx("input-field", { textarea: type === "textarea" }, { 'error': errorMessage })}
        {...(type === "textarea" ? { as: "textarea", rows: 4 } : {})}
      />
      {errorMessage && (
        <div className={cx("error-message")}>{errorMessage}</div>
      )}
    </div>
  );
};

export default BaseTextarea;
